<template>
    <div v-if="isShow" class="ks-button-panel flex flex-column shadow-2" :style="panelStyle">
        <template v-if="isMaximized">
            <div class="flex justify-content-end">
                <Button
                    @click="toggle"
                    icon="pi pi-window-maximize"
                    class="actions__icon_hide"
                    severity="secondary"
                    text
                    size="small"
                />
            </div>
            <div class="actions__content flex flex-column">
                <div v-if="$slots.header" class="flex flex-wrap">
                    <!-- блок перед кнопками -->
                    <slot name="header"></slot>
                </div>
                <div v-if="$slots.counter" class="flex flex-wrap">
                    <!-- блок со счетчиком выделенных элементов -->
                    <slot name="counter"></slot>
                </div>
                <div v-else>
                    <!-- дефолтный вывод счетчика -->
                    <p class="p-0 m-0">{{ getLabelCounts }}: <b>{{ selectedCount }}</b></p>
                </div>
                <div v-if="$slots.buttons" class="flex flex-wrap gap-2">
                    <!-- основные кнопки управления -->
                    <slot name="buttons"></slot>
                </div>
                <div v-if="$slots.footer" class="flex flex-wrap">
                    <!-- дополнительные опции -->
                    <slot name="footer"></slot>
                </div>
            </div>
        </template>
        <template v-else>
            <Button
                @click="toggle"
                icon="pi pi-cog"
                severity="secondary"
                size="small"
                text
            />
        </template>
    </div>
</template>
<script>
import Button from "primevue/button";

export default {
    name: "ActionsContainer",
    props: {
        selectedCount: {
            type: Number,
            required: true,
        },
        panelStyle: {
            type: Object,
            required: true,
        },
        // игнорирование, если есть слот #counter
        labelCounts: {
            type: String,
            required: false,
        },
        showOnEmpty: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    data() {
        return {
            rollUp: false,
        };
    },
    computed: {
        getLabelCounts() {
            return this.labelCounts ?? this.$t('lang.main.table.components.actions.selected_count');
        },
        isShow() {
            return this.showOnEmpty || this.selectedCount > 0;
        },
        isMaximized() {
            return !this.rollUp;
        }
    },
    methods: {
        toggle() {
            this.rollUp = !this.rollUp;
        },
    },
    watch: {
        selectedCount: {
            handler() {
                if (!this.showOnEmpty) {
                    return;
                }

                this.rollUp = this.selectedCount === 0;
            },
            immediate: true,
        },
    },
    components: {
        Button,
    }
}
</script>

<style scoped>
.ks-button-panel {
    position: fixed;
    right: 100px;
    background: #fff;
    z-index: 999;
    border-radius: var(--border-radius);
}
.actions__icon_hide {
    box-shadow: none !important;
}
.actions__content {
    padding: 0 1.875rem 1.875rem;
}
.actions__content > div:not(:last-child) {
    margin-bottom: 1.25rem;
}
@media (max-width: 576px) {
    .ks-button-panel {
        right: 0;
    }
}
</style>
